import React from 'react';
import { OrderCardProvider } from '../../../../contexts/card/cardOrder/context';
import MainLayout from './partials/MainLayout';
import SelectMainCardType from './SelectMainCardType';
import { orderCardFlowScreens } from './constants';
import ConfirmVirtualDetails from './ConfirmVirtualDetails';
import CardPromo from './CardPromo';
import SelectPayment from './SelectPayment';
import TopUpWallet from './TopUpWallet';
import ConfirmDetails from './ConfirmDetails';
import SelectPaymentType from './SelectPaymentType';
import ConfirmPayment from './ConfirmPayment';
import TopUpProcessing from './TopUpProcessing';
import TopUpReceiveExternally from './TopUpReceiveExternally';
import CardType from './CardType';
import ProceedWithPayment from './ProceedWithPayment';

const AddCardOrder = () => (
  <OrderCardProvider>
    <MainLayout>
      <CardType keyName={orderCardFlowScreens.CARD_TYPE} />
      <SelectMainCardType keyName={orderCardFlowScreens.SELECT_CARD_TYPE} />
      <ConfirmDetails keyName={orderCardFlowScreens.CONFIRM_DETAILS} />
      <SelectPaymentType keyName={orderCardFlowScreens.SELECT_PAYMENT_TYPE} />
      <ConfirmVirtualDetails keyName={orderCardFlowScreens.CONFIRM_VIRTUAL_DETAILS} />
      <CardPromo keyName={orderCardFlowScreens.FREE_CARD_PROMO} />
      <SelectPayment keyName={orderCardFlowScreens.SELECT_PAYMENT} />
      <ConfirmPayment keyName={orderCardFlowScreens.CONFORM_PAYMENT_DETAILS} />
      <TopUpWallet keyName={orderCardFlowScreens.LEDGER_DEPOSIT} />
      <TopUpProcessing keyName={orderCardFlowScreens.TRANSACTION_PROCESSED} />
      <TopUpReceiveExternally keyName={orderCardFlowScreens.RECEIVE} />
      <ProceedWithPayment keyName={orderCardFlowScreens.PROCEED_WITH_PAYMENT} />
    </MainLayout>
  </OrderCardProvider>
);

export default AddCardOrder;
